import { Action } from '@ngrx/store';

export enum OneClickQuantityActionTypes {
  SET_QUANTITY = '[One Click] Set quantity',
  RESET = '[One Click] quantity reset',
}

export class OneClickSelectQuantityAction implements Action {
  readonly type = OneClickQuantityActionTypes.SET_QUANTITY;

  constructor(public payload: number, public index: number) {}
}

export class OneClickResetQuantityAction implements Action {
  readonly type = OneClickQuantityActionTypes.RESET;

  constructor() {}
}

export type OneClickQuantityActions = OneClickSelectQuantityAction | OneClickResetQuantityAction;
